/* ============================================================
   SOLVEY · Weglot dev-only safety net
   ------------------------------------------------------------
   Weglot is in SUBDIRECTORY-mode: klik op een taal-flag → browser
   navigeert naar /nl/..., /de/..., /da/... Shopify Markets serveert
   die paths op live (HTTP 200), maar `shopify theme dev` proxiet
   markets-paths NIET → 404 op localhost.

   Deze script intercept flag-clicks op dev-host (127.0.0.1 /
   localhost / 0.0.0.0) en gebruikt Weglot.switchTo() programmatisch
   in plaats van navigatie. Live (solveyfem.com) wordt NIET geraakt,
   want de host-check faalt daar en de listener doet niets.
   ============================================================ */
(function () {
  'use strict';

  var DEV_HOSTS = /^(127\.0\.0\.1|localhost|0\.0\.0\.0)$/;
  if (!DEV_HOSTS.test(location.hostname)) return;

  function findFlag(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-l], .wg-li');
  }

  function getLang(el) {
    return el.getAttribute('data-l') ||
      (el.className.match(/\bwg-li\s+([a-z]{2})\b/) || [])[1] ||
      null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var flag = findFlag(e.target);
      if (!flag) return;
      var lang = getLang(flag);
      if (!lang) return;
      if (flag.classList.contains('wgcurrent')) return;
      if (!window.Weglot || typeof window.Weglot.switchTo !== 'function') return;
      if (window.Weglot.getCurrentLang && window.Weglot.getCurrentLang() === lang) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.Weglot.switchTo(lang);

      var container = flag.closest('.weglot-container, .country-selector');
      if (container) {
        container.classList.remove('is-open');
        container.classList.remove('open');
        container.classList.add('closed');
      }
    },
    true
  );
})();
